import { render, staticRenderFns } from "./AuthorityRequestDetail.vue?vue&type=template&id=0f5ad810&scoped=true"
import script from "./AuthorityRequestDetail.vue?vue&type=script&lang=js"
export * from "./AuthorityRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthorityRequestDetail.vue?vue&type=style&index=0&id=0f5ad810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ad810",
  null
  
)

export default component.exports